import { render, staticRenderFns } from "./paperList.vue?vue&type=template&id=65045076&scoped=true"
import script from "./paperList.vue?vue&type=script&lang=js"
export * from "./paperList.vue?vue&type=script&lang=js"
import style0 from "./paperList.vue?vue&type=style&index=0&id=65045076&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65045076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65045076')) {
      api.createRecord('65045076', component.options)
    } else {
      api.reload('65045076', component.options)
    }
    module.hot.accept("./paperList.vue?vue&type=template&id=65045076&scoped=true", function () {
      api.rerender('65045076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/requirementAnalysis/comps/paperList.vue"
export default component.exports